var map = {
	"./About.vue": [
		"f820",
		"chunk-7a3b542f"
	],
	"./CheckCode.vue": [
		"606d",
		"chunk-7a256507"
	],
	"./Contact.vue": [
		"b8fa",
		"chunk-36020dca"
	],
	"./Delivery.vue": [
		"edb0",
		"chunk-7a3b8acc"
	],
	"./Index.vue": [
		"d504",
		"chunk-4f2ead6c"
	],
	"./Information.vue": [
		"5798",
		"chunk-7a250b20"
	],
	"./News.vue": [
		"a2f9",
		"chunk-2e36bd61"
	],
	"./NewsCard.vue": [
		"55f2",
		"chunk-3523af65"
	],
	"./Privacy.vue": [
		"6f9f",
		"chunk-7a26301c"
	],
	"./Product.vue": [
		"d2f1",
		"chunk-10437c83"
	],
	"./Products.vue": [
		"e6dc",
		"chunk-8f98c112"
	],
	"./TermsAndConditions.vue": [
		"51c5",
		"chunk-7a24f9ad"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;